export const ja = {
  heroData: {
    title: "初めての方へ",
    subtitle: "初めてのヘリコプター遊覧でも、安心してお楽しみいただけます。事前に知っておくべきポイントをご案内します。",
    image: "https://readdy.ai/api/search-image?query=Modern%20helicopter%20on%20helipad%20during%20warm%20sunset%20with%20blue%20sky%2C%20clean%20and%20welcoming%20atmosphere%2C%20luxury%20aviation%20facility%2C%20editorial%20photography%20style%2C%20no%20text%2C%20high%20quality&width=1920&height=600&seq=fthero01&orientation=landscape",
  },
  stepsData: {
    label: "STEP",
    title: "3ステップで、特別な体験へ",
    steps: [
      { num: "01", icon: "ri-computer-line", title: "WEBで簡単相談", desc: "希望日・時間帯・人数・目的を入力するだけ。専任スタッフが最適なプランをご提案します。", details: ["24時間受付可能", "翌営業日以内にご連絡", "複数プランの比較OK"] },
      { num: "02", icon: "ri-suitcase-line", title: "出発前の準備", desc: "服装や持ち物、当日の流れを事前にガイド。不安な点はいつでもお問い合わせください。", details: ["服装ガイド送付", "持ち物チェックリスト", "ヘリポートアクセス案内"] },
      { num: "03", icon: "ri-flight-takeoff-line", title: "特別な体験へ", desc: "ヘリポートで受付後、パイロットと共に空へ。地上では見られない絶景が広がります。", details: ["受付・安全説明", "パイロット挨拶", "記念撮影（オプション）"] },
    ],
  },
  whatToWear: {
    label: "WHAT TO WEAR",
    title: "服装について",
    content: [
      { title: "おすすめの服装", items: ["動きやすい普段着", "ジャケットや上着（機内・屋外で羽織れるもの）", "足元が安定した靴（ヒールは細すぎるものを避ける）"] },
      { title: "避けていただきたい服装", items: ["スカート（特にミニスカートは風でめくれる可能性あり）", "細いヒール・サンダル", "帽子（風で飛ばされる可能性あり）"] },
    ],
  },
  whatToBring: {
    label: "WHAT TO BRING",
    title: "持ち物について",
    content: [
      { title: "持参すると便利なもの", items: ["身分証明書（運転免許証・パスポート等）", "カメラ・スマートフォン", "日焼け止め・サングラス（昼間コース）"] },
      { title: "機内への持ち込みができないもの", items: ["三脚・自撮り棒", "バッグ類（機内預かりになります）", "飲食物", "危険物・可燃物"] },
    ],
  },
  worriesData: {
    label: "WORRIES",
    title: "こんな不安、ありませんか？",
    items: [
      { q: "ヘリコプターって怖くないですか？", a: "初めての方が大多数です。エンジン音や浮遊感には最初驚かれるかもしれませんが、数分で慣れます。パイロットも丁寧に対応してくれます。" },
      { q: "揺れたりしますか？", a: "気流の影響で軽く揺れることはありますが、日常的な航空機と同様、安全な範囲内です。天候が悪い場合は欠航判断を行います。" },
      { q: "車椅子や足が不自由でも乗れますか？", a: "状況により異なります。事前にお問い合わせください。可能な限り対応いたします。" },
      { q: "子供も乗れますか？", a: "3歳以上であれば搭乗可能です。ただし、幼児の場合は保護者同乗が必要です。詳細はお問い合わせください。" },
      { q: "酔いやすい体質ですが大丈夫ですか？", a: "飛行時間は15〜40分程度で、揺れも少ないため、車酔いする方でも比較的平気な場合が多いです。心配な方は酔い止めを事前に服用することをおすすめします。" },
      { q: "写真は撮れますか？", a: "はい、スマートフォンやカメラでの撮影は可能です。ただし、機内では手ぶれに注意し、窓枠などにぶつけないようご注意ください。" },
    ],
  },
  finalCTA: {
    title: "準備は、あなたの心だけ。\nあとは私たちにお任せください",
    subtitle: "初めての体験だからこそ、丁寧にサポートいたします",
    ctas: [
      { label: "予約について問い合わせる", href: "/contact", type: "primary" },
      { label: "FAQを見る", href: "/faq", type: "secondary" },
    ],
  },
};

export const en = {
  heroData: {
    title: "First-Time Visitors",
    subtitle: "Even if it's your first helicopter tour, you can enjoy it with complete peace of mind. Here's everything you need to know in advance.",
    image: "https://readdy.ai/api/search-image?query=Modern%20helicopter%20on%20helipad%20during%20warm%20sunset%20with%20blue%20sky%2C%20clean%20and%20welcoming%20atmosphere%2C%20luxury%20aviation%20facility%2C%20editorial%20photography%20style%2C%20no%20text%2C%20high%20quality&width=1920&height=600&seq=fthero01&orientation=landscape",
  },
  stepsData: {
    label: "STEP",
    title: "Three Steps to a Special Experience",
    steps: [
      { num: "01", icon: "ri-computer-line", title: "Easy Online Inquiry", desc: "Simply enter your preferred date, time, number of guests, and purpose. Our dedicated staff will suggest the best plan.", details: ["Available 24 hours a day", "Response within the next business day", "Compare multiple plans"] },
      { num: "02", icon: "ri-suitcase-line", title: "Pre-Departure Preparation", desc: "We provide guidance on attire, what to bring, and the day-of schedule. Feel free to ask us anything at any time.", details: ["Attire guide sent in advance", "Packing checklist", "Helipad access guide"] },
      { num: "03", icon: "ri-flight-takeoff-line", title: "Your Special Experience", desc: "After check-in at the helipad, you will take off with the pilot — and breathtaking scenery unfolds before you.", details: ["Check-in & safety briefing", "Pilot introduction", "Commemorative photo (optional)"] },
    ],
  },
  whatToWear: {
    label: "WHAT TO WEAR",
    title: "What to Wear",
    content: [
      { title: "Recommended Attire", items: ["Comfortable everyday clothing", "A jacket or cardigan (something to layer at the helipad or in the cabin)", "Stable footwear (avoid very thin heels)"] },
      { title: "Attire to Avoid", items: ["Skirts that may blow up in the wind (especially miniskirts)", "Stilettos or sandals", "Hats (may be blown off by the wind)"] },
    ],
  },
  whatToBring: {
    label: "WHAT TO BRING",
    title: "What to Bring",
    content: [
      { title: "Useful Items to Bring", items: ["Photo ID (driver's license, passport, etc.)", "Camera or smartphone", "Sunscreen & sunglasses (for daytime courses)"] },
      { title: "Items Not Permitted in the Cabin", items: ["Tripods & selfie sticks", "Bags (will be stored at check-in)", "Food & beverages", "Hazardous or flammable items"] },
    ],
  },
  worriesData: {
    label: "WORRIES",
    title: "Common Concerns — Answered",
    items: [
      { q: "Isn't it scary?", a: "Most of our guests are first-timers. The engine noise and floating sensation may surprise you at first, but you will get used to it within a few minutes. The pilot is always there to reassure you." },
      { q: "Will it be bumpy?", a: "There may be slight turbulence due to air currents, but it is within the safe range — similar to any other aircraft. Flights are cancelled if weather conditions are poor." },
      { q: "Can people with wheelchairs or mobility issues fly?", a: "It depends on the situation. Please contact us in advance and we will do our best to accommodate you." },
      { q: "Can children fly?", a: "Children aged 3 and above may fly. However, infants must be accompanied by a parent or guardian. Please contact us for details." },
      { q: "I get motion sick easily — will I be okay?", a: "Flight duration is approximately 15–40 minutes with minimal turbulence, so many people who experience car sickness find it manageable. If you are concerned, we recommend taking motion sickness medication in advance." },
      { q: "Can I take photos?", a: "Yes, photos with a smartphone or camera are allowed. Please be careful of vibration inside the cabin and avoid hitting the windows." },
    ],
  },
  finalCTA: {
    title: "Just bring your excitement —\nwe'll handle the rest",
    subtitle: "Because it's your first time, we will support you every step of the way",
    ctas: [
      { label: "Inquire About Booking", href: "/contact", type: "primary" },
      { label: "View FAQ", href: "/faq", type: "secondary" },
    ],
  },
};
